import { INTEGRATION_TYPES } from '@vy/integrations-types';
import { notDefined } from '@vy/null';
import type { ExternalProductIntegration, PaddleProductEntity, QuickBooksProduct, QuickBooksProductEntity, XeroProduct, XeroProductEntity } from '@vy/types';
import { SYNC_STATUSES } from '@vy/types';
import { now, type Optional } from '@vy/utils';
import type { PaddleProductPayload } from '@vy/api-definition';

export function buildQuickBooksEntityFromExternalIntegration(
  externalIntegration: Optional<ExternalProductIntegration>,
  quickBooksProducts: QuickBooksProduct[],
): Optional<QuickBooksProductEntity> {
  if (notDefined(externalIntegration) || externalIntegration.type !== INTEGRATION_TYPES.QUICKBOOKS) {
    return undefined;
  }

  const matchingProduct = quickBooksProducts.find((product) => product.id === externalIntegration.id);

  return {
    integrationProvider: INTEGRATION_TYPES.QUICKBOOKS,
    integrationExternalId: externalIntegration.id,
    updatedAt: now(),
    syncStatus: SYNC_STATUSES.Synced,
    metadata: {
      name: matchingProduct?.name ?? 'Unnamed Product',
    },
  };
}

export function buildXeroEntityFromExternalIntegration(
  externalIntegration: Optional<ExternalProductIntegration>,
  xeroProducts: XeroProduct[],
): Optional<XeroProductEntity> {
  if (notDefined(externalIntegration) || externalIntegration.type !== INTEGRATION_TYPES.XERO) {
    return undefined;
  }

  const matchingProduct = xeroProducts.find((product) => product.id === externalIntegration.id);

  return {
    integrationProvider: INTEGRATION_TYPES.XERO,
    integrationExternalId: externalIntegration.id,
    updatedAt: now(),
    syncStatus: SYNC_STATUSES.Synced,
    metadata: {
      name: matchingProduct?.name ?? 'Unnamed Product',
    },
  };
}

export function buildPaddleEntityFromExternalIntegration(
  externalIntegration: Optional<ExternalProductIntegration>,
  paddleProducts: PaddleProductPayload[],
): Optional<PaddleProductEntity> {
  if (notDefined(externalIntegration) || externalIntegration.type !== INTEGRATION_TYPES.PADDLE) {
    return undefined;
  }

  const matchingProduct = paddleProducts.find((product) => product.id === externalIntegration.id);

  return {
    integrationProvider: INTEGRATION_TYPES.PADDLE,
    integrationExternalId: externalIntegration.id,
    updatedAt: now(),
    syncStatus: SYNC_STATUSES.Synced,
    metadata: {
      name: matchingProduct?.name ?? 'Unnamed Product',
    },
  };
}
